export const GET_FREELANCER_FILTERS_DATA_SUCCESS = 'GET_FREELANCER_FILTERS_DATA_SUCCESS';
export const GET_FREELANCER_FILTERS_DATA_FAILED = 'GET_FREELANCER_FILTERS_DATA_FAILED';
export const GET_FREELANCER_FINANCIALS_TOTALS_SUCCESS = 'GET_FREELANCER_FINANCIALS_TOTALS_SUCCESS';
export const GET_FREELANCER_FINANCIALS_LIST_SUCCESS = 'GET_FREELANCER_FINANCIALS_LIST_SUCCESS';
